import { IContainer, ILazyBinder, injectContainer } from './container';
import { IProgressPromise } from './promise';

export interface IFetchHeader {
    name: string;
    value: string;
}

export type Method = 'GET' | 'PUT' | 'PATCH' | 'POST' | 'DELETE' | 'OPTIONS';
export type ResponseTypes = 'json' | 'text' | 'blob' | 'arraybuffer';

export interface IFetchRequest {
    url: string;
    method?: Method;
    headers?: Array<IFetchHeader>;
    body?: string;
    expectedResponseType?: ResponseTypes;
    expectedResponseSize?: number;
}

export interface IFetchResponse<T> {
    request: IFetchRequest;
    statusCode: number;
    isStatusOk: boolean;
    error?: Error;
    payload: T | null;
}

export type IFetcher = <T>(
    requestPayload: IFetchRequest,
    timeout?: number,
) => IProgressPromise<IFetchResponse<T>>;

const TYPES = {
    IFetch: Symbol.for('IFetch'),
};

export function injectFetch(container: IContainer = injectContainer()): Promise<IFetcher> {
    return container.get<ILazyBinder<IFetcher>>(TYPES.IFetch)();
}

export function bindFetch(val: ILazyBinder<IFetcher>, container: IContainer = injectContainer()) {
    return container.bind<ILazyBinder<IFetcher>>(TYPES.IFetch, val);
}
